import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../Dialog';
import { cn } from '../../lib/utils';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  contentClassName?: string;
  shouldCloseOnEsc?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  containerClassName?: string;
  /** When true, drag the dialog by the title bar (`.drag-handle` on `DialogHeader`). */
  isDraggable?: boolean;
  /** Base transform for draggable dialogs (e.g. `translate(0, 0)` for corner-anchored). */
  draggableBaseTransform?: string;
  onMinimize?: () => void;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  shouldCloseOnEsc = true,
  shouldCloseOnOverlayClick = true,
  containerClassName,
  isDraggable = false,
  draggableBaseTransform,
  onMinimize,
}) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      shouldCloseOnEsc={shouldCloseOnEsc}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      isDraggable={isDraggable}
      draggableBaseTransform={draggableBaseTransform}
      onMinimize={onMinimize}
    >
      <DialogContent className={containerClassName}>
        {title && (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        <div className={cn('mt-2')}>{children}</div>
      </DialogContent>
    </Dialog>
  );
};

export default Modal;
